import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useStockMonitoringRealtime = () => {
  const queryClient = useQueryClient();
  
  useEffect(() => {
    // Subscribe to notification_product_monitoring changes
    const monitoringChannel = supabase
      .channel('stock-monitoring-realtime')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'notification_product_monitoring'
        },
        (payload) => {
          const data = payload.new || payload.old;
          if (data && 'notification_id' in data && data.notification_id) {
            // Only invalidate the specific notification's stock status
            queryClient.invalidateQueries({ 
              queryKey: ['stock-status', data.notification_id] 
            });
          }
        }
      )
      .subscribe();

    // Subscribe to notification_inventory_checks changes
    const inventoryChannel = supabase
      .channel('inventory-checks-realtime')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'notification_inventory_checks'
        },
        async (payload) => {
          // Get the notification_id from monitoring_id
          const data = payload.new || payload.old;
          if (data && 'monitoring_id' in data && data.monitoring_id) {
            const { data: monitoring } = await supabase
              .from('notification_product_monitoring')
              .select('notification_id')
              .eq('id', data.monitoring_id)
              .single();
            
            if (monitoring?.notification_id) {
              queryClient.invalidateQueries({ 
                queryKey: ['stock-status', monitoring.notification_id] 
              });
            }
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(monitoringChannel);
      supabase.removeChannel(inventoryChannel);
    };
  }, [queryClient]);
};
